import React from 'react';
import { Button, Image, LinkBox, LinkOverlay, VStack, Box, Icon, Stack } from '@chakra-ui/react';
import ReactPlayer from 'react-player/youtube';
import { ExternalLinkIcon } from '@chakra-ui/icons';

import HeadingWithText from '../../../components/sections/headingwithtext';
import HeroWithRightMedia from '../../../components/sections/herowithrightmedia';
import Recos from '../../../components/sections/recos';

import colTestedTough from '../../../components/ui/columbia-tested-tough.jpg';
import colOffice from '../../../components/ui/columbia-office.jpg';
import SocialButton from '../../../components/sections/socialbutton';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaYoutube } from 'react-icons/fa';

export default function ColumbiaTabPanel() {
  return (
    <Box>
      <VStack>
        <HeadingWithText
          title='HELP US UNLOCK THE OUTDOORS FOR EVERYONE'
          subTitle='Columbia exists to make sure the great outside moments in life happen for everyone. We want people to get out there, looking the way they want to and feeling totally prepared. Just surviving the elements isn’t good enough. Our job is to help people thrive in the sun, rain, snow, heat—whatever comes and whatever thriving means to them.'
          justify='center'
          align='center'
          my={4}
          mx={180}
        />
        <HeroWithRightMedia
          title='WHO WE ARE'
          subTitle='Columbia is different. As a global apparel and footwear company with over 80 years of being ourselves and not apologizing for it, we’ve seen a lot and done a lot. But our motto remains: “It’s perfect. now make it better.”\n\nHelp us shape the next 80 years.'
          cta={
            <LinkBox as='a'>
              <LinkOverlay href='https://columbiasportswearcompany.wd5.myworkdayjobs.com/CSC_Careers' isExternal>
                <Button size='lg' px={6} bg='black' color='white' borderRadius={0}>VIEW JOBS AT COLUMBIA<Icon
                  color='white' w={5} h={5} as={ExternalLinkIcon} pl='4px' /></Button>
              </LinkOverlay>
            </LinkBox>}
          media={<ReactPlayer
            url='https://www.youtube.com/embed/g3XXMqhcEk8?autoplay=0&rel=0&enablejsapi=1&wmode=opaque' />} />
        <HeroWithRightMedia
          title='WHAT WE BELIEVE'
          subTitle={`Favorite sayings include:\n\n"Move outside the expected.”\n“Shivering is nature’s way of telling you that you bought the wrong jacket.”\n“If you can’t stand the heat, you’re not wearing Columbia.”\n\nWe believe in including innovation for everyone, which makes us open, curious, and willing to question everything. We also believe deeply in toughness – of product and people. Are you Tested Tough?`}
          media={<Image src={colTestedTough} borderRadius={10} />}
        />
        <HeroWithRightMedia
          title='HOW WE WORK'
          subTitle='Columbia is a highly collaborative company where inclusion and being ourselves plays a big role every day. In fact, most of the people who work here would say that at our core, we are much more than a leading global footwear and apparel company: we are a family (and we work like one).'
          cta={
            <LinkBox as='a'>
              <LinkOverlay href='https://columbiasportswearcompany.wd5.myworkdayjobs.com/CSC_Careers' isExternal>
                <Button size='lg' px={6} bg='black' color='white' borderRadius={0}>VIEW JOBS AT COLUMBIA<Icon
                  color='white' w={5} h={5} as={ExternalLinkIcon} pl='4px' /></Button>
              </LinkOverlay>
            </LinkBox>}
          media={<Image src={colOffice} borderRadius={10} />}
        />
        <LinkBox as='a'>
          <LinkOverlay href='https://www.columbia.com' isExternal>
            <Button bg='black' color='white' size='lg' borderRadius={0} rightIcon={<ExternalLinkIcon />}>Visit
              Columbia.com</Button>
          </LinkOverlay>
        </LinkBox>
        <Recos siteId='bcpx-Columbia_US' title='Our Best Sellers' />
        <HeadingWithText title='FOLLOW COLUMBIA' />
        <Stack direction='row' spacing={6}>
          <SocialButton label='Facebook' href='https://www.facebook.com/ColumbiaSportswear/'>
            <FaFacebook size='40px' />
          </SocialButton>
          <SocialButton label='Instagram' href='https://www.instagram.com/columbia1938/?hl=en'>
            <FaInstagram size='40px' />
          </SocialButton>
          <SocialButton label='Twitter' href='https://twitter.com/columbia1938?lang=en'>
            <FaTwitter size='40px' />
          </SocialButton>
          <SocialButton label='YouTube' href='https://www.youtube.com/user/ColumbiaSportswear'>
            <FaYoutube size='40px' />
          </SocialButton>
          <SocialButton label='LinkedIn' href='https://www.linkedin.com/company/columbia-sportswear'>
            <FaLinkedin size='40px' />
          </SocialButton>
        </Stack>
      </VStack>
    </Box>
  );
}
